import LanguageContext from "components/LanguageContext";
import SiteContext from "components/SiteContext";
import React, { useContext, useMemo, useState } from "react";
import t from "utils/locales/translation.json";

const boxStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  position: "fixed",
  right: "16px",
  bottom: "16px",
  width: "210px",
  height: "68px",
  zIndex: "9999999",
  paddingLeft: "11px",
};

const buttonStyle = {
  boxShadow: "0px 2.5px 5px 0px #d1d5db",
  backgroundColor: "#fff",
  color: "#030712",
  fontWeight: 400,
  margin: "0.5rem",
  paddingTop: "0.5rem",
  paddingBottom: "0.5rem",
  paddingRight: "0.75rem",
  paddingLeft: "0.5rem",
  lineHeight: "24px",
  position: "relative",
  fontFamily: "arial,sans-serif",
};

const LoadBot = () => {
  const [isBotCharged, setIsBotCharged] = useState(false);

  const site = useContext(SiteContext);
  const { language } = useContext(LanguageContext);
  const { name: currentSiteName } = site || {};

  const chatBotId = useMemo(() => {
    switch (currentSiteName) {
      case "IMMAT":
        return process.env.chatbot_project_id_immat;
      case "PERMIS":
        return process.env.chatbot_project_id_permis;
      default:
        return undefined;
    }
  }, [currentSiteName]);

  if (!chatBotId) return null;

  const loadBot = async () => {
    if (!document.getElementById("lightchat-bot") && !!chatBotId) {
      const script = document.createElement("script");

      script.type = "module";
      script.src = "https://genii-script.tolk.ai/lightchat.js";
      script.id = "lightchat-bot";

      script.setAttribute("project-id", chatBotId);

      script.setAttribute("template", "widget");
      script.onload = () => {
        const forceOpen = setInterval(() => {
          if (window.genii) {
            window.genii.open();
          }
        }, 100);
        const interval = setInterval(() => {
          if (window.genii) {
            window.genii.onCoreWidgetIframeLoaded(() => {
              setIsBotCharged(true);
              clearInterval(forceOpen);

              setTimeout(() => {
                document
                  .querySelector("#genii-iframe-core")
                  .contentWindow.document.querySelector("#genii-form-input")
                  .focus();
              }, 200);
            });
            clearInterval(interval);
            return;
          }
        }, 100);
      };

      document.body.appendChild(script);
    }
  };

  return (
    !isBotCharged && (
      <div style={boxStyle}>
        <button type="button" style={buttonStyle} onClick={loadBot}>
          <img
            alt="Assistant avatar: Bot FranceTitres"
            style={{ width: "2.625rem", display: "inline-block", verticalAlign: "middle", marginRight: "0.75rem" }}
            src="/chat-bot-icon.png"
          />
          <span
            style={{
              width: "14px",
              left: "2.2em",
              height: "14px",
              bottom: ".4em",
              content: " ",
              position: "absolute",
              borderRadius: "9999px",
              background: "#84cc16",
              border: "2px solid #f9fafb",
            }}
          ></span>
          <span>{t[language].components.help_bot}</span>
        </button>
      </div>
    )
  );
};

export default LoadBot;
